import api from './api'; // Ton instance Axios configurée avec withCredentials

const candidateService = {
  
  // --- PROFIL ---
  // Appelle ta vue : candidate_profile_get
  getProfile: async () => {
    const response = await api.get('/candidates/profile/');
    return response.data.data; // On extrait le champ "data" de ta réponse Django
  },

  // Appelle ta vue : candidate_profile_put
  updateProfile: async (profileData) => {
    const response = await api.put('/candidates/profile/update/', profileData); // Mis à jour selon les docs
    return response.data.data;
  },

  // --- STATS / DATA ---
  // Appelle ta vue : candidate_data_get
  getCandidateData: async () => {
    const response = await api.get('/candidates/data/');
    return response.data.data;
  },

  // --- TESTS SAUVEGARDÉS ---
  // Appelle ta vue : saved_tests_get
  getSavedTests: async () => {
    const response = await api.get('/candidates/saved-tests/');
    return response.data.data;
  },

  // Appelle ta vue : saved_tests_post (CORRIGÉ !)
  saveTest: async (testId) => {
    // Route correcte d'après l'API doc : /api/candidates/saved-tests/create/<id>/
    const response = await api.post(`/candidates/saved-tests/create/${testId}/`);
    return response.data;
  },

  // --- SOUMISSIONS (TESTS PASSÉS) ---
  // Appelle ta vue : submissions_get
  getSubmissions: async () => {
    const response = await api.get('/candidates/submissions/');
    return response.data.data;
  },

  // Appelle ta vue : submissions_post (CORRIGÉ !)
  submitTest: async (testId, flag) => {
    // Route correcte d'après l'API doc : /api/candidates/submissions/create/<id>/
    const response = await api.post(`/candidates/submissions/create/${testId}/`, {
      submitted_flag: flag
    });
    return response.data;
  },

  // --- RÉCUPÉRER LE FLAG D'UN TEST ---
  // Appelle ta vue : get_test_flag
  getTestFlag: async (testId) => {
    // Route correcte d'après l'API doc : /api/candidates/test/<id>/flag/
    const response = await api.get(`/candidates/test/${testId}/flag/`);
    return response.data.data;
  }
};

export default candidateService;